/*jshint esversion: 9 */
import { mapGetters } from 'vuex';
import TWorkPackage from '@/components/ProjectTaktPlan/Workpackage.component.vue';
export const TWorkPackageMixin = {
  components: {
    TWorkPackage
  },
  computed: {
    ...mapGetters('TWorkPackage', [
      'getTWorkPackage',
      'getTWorkPackages',
      'getTWorkpackageIcons',
      'getTWorkpackageColors'
    ]),
  },
  methods: {
    handleTWorkpackageClick(train, waggon, work_package, train_id, taktarea_id, waggon_id, workpackage_id, evt) {
      if (this.$route.name === 'TrainMilestonesAdd' &&
        this.getNewMilestone(this.project_id).milestone.linkType === 'selection') {
        this.editNewMilestoneSelection({
          project_id: this.project_id,
          prop: 'tworkpackages',
          value: work_package,
          train: train,
        });
      }
      else if (this.$route.name === 'TrainMilestonesAdd' &&
        this.getNewMilestone(this.project_id).milestone.linkType === 'type') {
        this.updateNewMilestoneBulk([
          {prop: 'wp_color_active', value: true},
          {prop: 'wp_color', value: work_package.color},
          {prop: 'wp_token_active', value: true},
          {prop: 'wp_token', value: work_package.token},
          {prop: 'wp_icon_active', value: true},
          {prop: 'wp_icon', value: work_package.icon},
          {prop: 'wp_name_active', value: true},
          {prop: 'wp_name', value: work_package.name},
        ]);
      }
      else if (this.$route.name === 'TrainMilestonesEdit' &&
          this.getMileStoneLinkType({
            project_id: this.project_id,
            milestone_id: this.$route.params.milestone_id
          }) === 'selection') {
        this.editMilestoneSelection({
          project_id: this.project_id,
          milestone_id: this.$route.params.milestone_id,
          prop: 'tworkpackages',
          value: work_package,
          train: train,
        });
      }
      else if (this.$route.name === 'TrainMilestonesEdit' &&
          this.getMileStoneLinkType({
            project_id: this.project_id,
            milestone_id: this.$route.params.milestone_id
          }) === 'type') {
        this.updateMilestoneBulk({
          project_id: this.project_id,
          milestone_id: this.$route.params.milestone_id,
          type: 'milestones',
          data: [
            {prop: 'wp_color_active', value: true},
            {prop: 'wp_color', value: work_package.color},
            {prop: 'wp_token_active', value: true},
            {prop: 'wp_token', value: work_package.token},
            {prop: 'wp_icon_active', value: true},
            {prop: 'wp_icon', value: work_package.icon},
            {prop: 'wp_name_active', value: true},
            {prop: 'wp_name', value: work_package.name},
          ]
        });
      }
      else {
        this.openWaggonInfo(
          waggon,
          train_id,
          taktarea_id,
          waggon_id,
          evt,
          workpackage_id,
        );
      }
    },
    isTworkPackageHover(workpackage_id, workpackage, hover, new_milestone) {
      if (hover && this.$route.name !== 'ProjectTaktPlan') {
        return true;
      }
      else if (!this.snackbar.hover && this.$route.matched[4] && this.$route.matched[4].name.substring(0,19) === 'TaktPlanWorkPackage' && this.$route.params.tworkpackage_id === workpackage_id) {
        return true;
      }
      else if (this.$route.name === 'TrainMilestonesAdd' && new_milestone.linkType === 'selection' &&
        new_milestone.work_packages.findIndex(work_package => work_package.id === workpackage_id) !== -1) {
        return true;
      }
      else if (this.$route.name === 'TrainMilestonesAdd' && new_milestone.linkType === 'type' &&
        ((new_milestone.wp_color_active && new_milestone.wp_color === workpackage.color) || !new_milestone.wp_color_active) &&
        ((new_milestone.wp_token_active && new_milestone.wp_token === workpackage.token) || !new_milestone.wp_token_active) &&
        ((new_milestone.wp_icon_active && new_milestone.wp_icon === workpackage.icon) || !new_milestone.wp_icon_active) &&
        ((new_milestone.wp_name_active && new_milestone.wp_name === workpackage.name) || !new_milestone.wp_name_active) &&
        !(!new_milestone.wp_color_active && !new_milestone.wp_token_active && !new_milestone.wp_icon_active && !new_milestone.wp_name_active)) {
        return true;
      }
      else if (['TrainMilestonesDetails', 'TrainMilestonesEdit'].includes(this.$route.name) &&
        this.milestone_selection.work_packages.findIndex(work_package => work_package.id === workpackage_id) !== -1) {
        return true;
      }
      else if (this.snackbar && this.snackbar.show && this.snackbar.hover) {
        if (this.snackbar.action !== 'updateparent' && this.snackbar.target_type === 'tworkpackages' && this.getAffectedTargets.includes(workpackage_id)) {
          return true;
        }
        else if (this.snackbar.target_type.substring(this.snackbar.target_type.length-5) === 'steps' && this.snackbar.affected_parents.includes(workpackage_id)) {
          return true;
        }
        else {
          return false;
        }
      } else {
        return false;
      }
    }
  }
};
